<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Salary addition')"
          :description="$t('From here you can add new employees salaries')"
        />
        <indexTable
          :searchText="$t('Search for a salary')"
          :emptyTableText="$t('There are no pay cheques')"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :buttonRole="$checkRole('employees_salaries_add')"
          :statusSearch="true"
          :statusValues="[
            { title: $t('Situation'), value: '' },
            { title: $t('All'), value: '' },
            { title: $t('Draft'), value: 0 },
            { title: $t('Approved'), value: 1 }
          ]"
          :cloumns="[
            {
              column: 'code',
              title: $t('Salary'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'employee_id',
              title: $t('Functionary'),
              type: 'link',
              to: 'employee',
              sort: true,
              link: true
            },
            {
              column: 'date',
              title: $t('Date'),
              type: 'text',
              sort: true
            },
            {
              column: 'description',
              title: $t('Thats about'),
              type: 'text',
              sort: true
            },
            {
              column: 'notes',
              title: $t('Note'),
              type: 'text',
              sort: true
            },
            {
              column: 'cost',
              title: $t('Cost'),
              type: 'text',
              sort: true
            },
            {
              column: 'user_name',
              title: $t('Responsible name'),
              type: 'text',
              sort: true
            },
            {
              column: 'status',
              title: $t('Situation'),
              type: 'status',
              sort: true,
              values: [
                { title: $t('Draft'), value: 0, color: 'dark' },
                { title: $t('Approved'), value: 1, color: 'success' }
              ]
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'show' },
                { name: 'printEmployeesSalarie', role: true },
                {
                  name: 'edit',
                  role: $checkRole('employees_salaries_edit')
                },
                { name: 'file' },
                { name: 'download', role: true },
                {
                  name: 'delete',
                  role: $checkRole('employees_salaries_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'

export default {
  data() {
    return {
      path: '/employeesSalaries'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
